import React from "react";
import Expander from "../../Expander";
import { getVarsoUrl } from "../../../common/helpers/helpers";

export const getDrugLabelAnnotationsTableMobile = (items) => {
  const result = (
    <div>
      <Expander showMore="5">
        {items.map((item, key) => {
          return (
            <dl className="dl-horizontal varsome-dl-horizontal" key={item.key}>
              <span>
                <dt className="col-12 col-xs-12">Drug</dt>
                <dd className="col-12 col-xs-12">
                  {item.drugNameIdUrl ? (
                    <a href={getVarsoUrl(item.drugNameIdUrl)} target="_blank">
                      {item.name || "-"}
                    </a>
                  ) : (
                    item.name || "-"
                  )}
                </dd>
              </span>
              {item.drug_label_annotations &&
                item.drug_label_annotations.length > 0 &&
                item.drug_label_annotations.map((i, j) => {
                  const k = `${j}-${i}`;
                  return (
                    <span key={k}>
                      {i.drugLabelNameIdUrl && i.name && (
                        <span>
                          <dt className="col-12 col-xs-12">Title</dt>
                          <dd className="col-12 col-xs-12">
                            <a
                              href={getVarsoUrl(i.drugLabelNameIdUrl)}
                              target="_blank"
                            >
                              {i.name}
                            </a>
                          </dd>
                        </span>
                      )}
                      {i.testing_level && (
                        <span>
                          <dt className="col-12 col-xs-12">
                            <a
                              href="https://www.pharmgkb.org/page/drugLabelLegend"
                              target="_blank"
                            >
                              PGX Level
                            </a>
                          </dt>
                          <dd className="col-12 col-xs-12">
                            {i.testing_level}
                          </dd>
                        </span>
                      )}
                      {i.biomarker_flag && (
                        <span>
                          <dt className="col-12 col-xs-12">
                            <a
                              href="https://www.fda.gov/drugs/science-and-research-drugs/table-pharmacogenomic-biomarkers-drug-labeling"
                              target="_blank"
                            >
                              FDA Biomarker List
                            </a>
                          </dt>
                          <dd className="col-12 col-xs-12">
                            {i.biomarker_flag}
                          </dd>
                        </span>
                      )}
                      {key === item.drug_label_annotations.length - 1 ? (
                        ""
                      ) : (
                        <hr />
                      )}
                    </span>
                  );
                })}
            </dl>
          );
        })}
      </Expander>
    </div>
  );
  return result;
};
